// src/admin/components/MovementModal.js
import React, { useState } from 'react';
import { API_BASE_URL } from '../config';

export default function MovementModal({ item, onClose, onSuccess }) {
  const [quantityChange, setQuantityChange] = useState('');
  const [costPerUnit, setCostPerUnit] = useState('');
  const [reason, setReason] = useState('');

  const token = localStorage.getItem('access_token');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!quantityChange) {
      alert('Inserisci la quantità da aggiungere o sottrarre.');
      return;
    }

    try {
      const url = `${process.env.REACT_APP_API_URL}/restaurant_ingredients/${item.id}/movements`;
      const payload = {
        quantity_change: parseFloat(quantityChange),
        cost_per_unit: costPerUnit ? parseFloat(costPerUnit) : null,
        reason: reason || '',
      };

      const res = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const err = await res.json();
        alert(err.detail || 'Errore nel movimento di inventario');
        return;
      }

      alert('Movimento registrato con successo!');
      onSuccess();
    } catch (error) {
      console.error('MovementModal error:', error);
      alert('Errore di rete o server');
    }
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h2 style={styles.title}>Movimento Inventario</h2>
        <p style={styles.infoLine}>
          Prodotto: <strong>{item.ingredient_name}</strong> (ID: {item.id})
        </p>
        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.field}>
            <label style={styles.label}>Quantità (+/-):</label>
            <input
              type="number"
              step="0.01"
              value={quantityChange}
              onChange={(e) => setQuantityChange(e.target.value)}
              style={styles.input}
              placeholder="+5 o -3"
            />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Prezzo unit. (solo per carico +):</label>
            <input
              type="number"
              step="0.01"
              value={costPerUnit}
              onChange={(e) => setCostPerUnit(e.target.value)}
              style={styles.input}
              placeholder="Es. 1.50"
            />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Motivo:</label>
            <input
              type="text"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              style={styles.input}
              placeholder="Es. Rifornimento, merce scaduta..."
            />
          </div>
          <div style={styles.buttonRow}>
            <button type="submit" style={styles.saveBtn}>
              Salva
            </button>
            <button type="button" style={styles.cancelBtn} onClick={onClose}>
              Annulla
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0,0,0,0.4)', // Overlay
    zIndex: 9999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modal: {
    backgroundColor: '#FFFFFF',
    padding: '20px',
    borderRadius: '8px',
    width: '400px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
  },
  title: {
    marginTop: 0,
    marginBottom: '10px',
    color: '#333',
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },
  infoLine: {
    margin: '0 0 10px 0',
    color: '#333',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    marginBottom: '4px',
    fontWeight: '500',
    color: '#333333',
  },
  input: {
    padding: '8px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    fontSize: '0.9rem',
  },
  buttonRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
    marginTop: '10px',
  },
  saveBtn: {
    backgroundColor: '#FF8C00',
    color: '#fff',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '4px',
    cursor: 'pointer',
    fontWeight: 'bold',
  },
  cancelBtn: {
    backgroundColor: '#555',
    color: '#fff',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '4px',
    cursor: 'pointer',
  },
};
